import React, { Component } from "react";

class Theme extends Component {
	constructor() {
		super();

		this.state = {
			skin: "dark"
		}

		this.handleClick = this.handleClick.bind(this);
	}

	async handleClick() {
		await this.setState({
			skin: this.state.skin === "dark" ? "light" : "dark"
		});

		this.updateTheme();
	}

	updateTheme() {
		document.body.setAttribute("skin", this.state.skin);
		console.log(this.state.skin);
	}

	render() {
		let themeName = this.state.skin === "dark" ? "Light" : "Dark";

		return (
			<div className="switch-theme" >
				<a
					href="/#"
					onClick={this.handleClick}>
					Switch to {themeName} Theme
				</a>
			</div >
		);
	}
}

export default Theme;